import React, { useState, useEffect, Suspense } from "react";
import { useSearchParams } from "react-router-dom";
import SweetAlert from "react-bootstrap-sweetalert";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import "../../assets/css/inventorymanagement.css";

// Lazy load components
const STNDashboard = React.lazy(() => import("./dashboard.js"));
const StockValidation = React.lazy(() => import("./stockvalidation.js"));
const HistoricSalesInsights = React.lazy(() => import('./historicsalesinsights.js'));
const CurrentStockDashboard = React.lazy(() => import('./currentstockdashboards.js'));
const PotentialRisk = React.lazy(() => import('./potentialrisk.js'));


const tabs = [
  { label: "STN Dashboard", value: "stn_dashboard" },
  { label: "FG Stock Validation", value: "fg_stock_validation" },
  // { label: "Historic Sales Dashboard", value: "historic_sales_dashboard" },
  { label: "Current Stock Dashboard", value: "current_stock_dashboard" },
  { label: "Potential Risk", value: "potential_risk_dashboard" },

];

const InventoryDashboards = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const defaultTab = searchParams.get("tab") || "potential_risk_dashboard";

  const [activeTab, setActiveTab] = useState(defaultTab);
  const [loadshow, setLoadshow] = useState("show-n");
  const [overlayBlock, setOverlayBlock] = useState("show-n");
  const [overlyBlock, setOverlyBlock] = useState("show-n");
  const [show, setShow] = useState(false);
  const [basicTitle, setBasicTitle] = useState("");
  const [basicType, setBasicType] = useState("default");

  useEffect(() => {
    setSearchParams({ tab: activeTab });
  }, [activeTab, setSearchParams]);

  const hideOverlySlideBlock = () => {
    setOverlyBlock("show-n");
    setLoadshow("show-n");
  };

  const closeAlert = () => {
    setShow(false);
    setLoadshow("show-n");
    setOverlayBlock("show-n");
    setOverlyBlock("show-n");
  };

  const handleTabClick = (tabValue) => {
    setActiveTab(tabValue);
  };

  const renderTabContent = () => {
    const loadingFallback = <div className="text-center p-4">Loading...</div>;

    switch (activeTab) {
      case "stn_dashboard":
        return <Suspense fallback={loadingFallback}><STNDashboard /></Suspense>;
      case "fg_stock_validation":
        return <Suspense fallback={loadingFallback}><StockValidation /></Suspense>;
      case "historic_sales_dashboard":
        return <Suspense fallback={loadingFallback}><HistoricSalesInsights /></Suspense>;
      case "current_stock_dashboard":
        return <Suspense fallback={loadingFallback}><CurrentStockDashboard /></Suspense>;
      case "potential_risk_dashboard":
        return <Suspense fallback={loadingFallback}><PotentialRisk /></Suspense>;
      default:
        return null;
    }
  };

  return (
    <>
      <div className="container-fluid mt-3">
        {/* SweetAlert */}
        <div style={{ zIndex: "9999999" }}>
          <SweetAlert
            show={show}
            type={basicType}
            title={basicTitle}
            onConfirm={closeAlert}
            style={{ fontSize: "9px" }}
          />
        </div>

        <div className="row" style={{ fontSize: "0.9rem", fontFamily: "Arial, sans-serif" }}>
          <div className="col-sm-12 p-0">
            <h1 style={{ color: "#B9366D", fontSize: 18, fontWeight: "bold", fontFamily: "sans-serif" }}>
              Inventory Dashboards
            </h1>
          </div>

          {/* Tabs */}
          <div className="col-sm-12 p-0 mt-3">
            <ul className="nav nav-tabs" role="tablist" style={{ borderBottom: "1px solid #dee2e6" }}>
              {tabs.map((tab) => (
                <li key={tab.value} className="nav-item" role="presentation">
                  <button
                    type="button"
                    className={`nav-link ${activeTab === tab.value ? "active" : ""}`}
                    onClick={() => handleTabClick(tab.value)}
                    style={{
                      fontSize: "14px",
                      fontWeight: activeTab === tab.value ? 600 : 500,
                      color: activeTab === tab.value ? "#93385D" : "#555",
                      backgroundColor: activeTab === tab.value ? "#fff" : "#f8f9fa",
                      border: "none",
                      borderBottom: `2px solid ${
                        activeTab === tab.value ? "#93385D" : "transparent"
                      }`,
                      padding: "8px 20px",
                      cursor: "pointer",
                      transition: "all 0.3s ease",
                    }}
                  >
                    {tab.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Tab content */}
          <div className="tab-content col-sm-12 p-0 mt-2">{renderTabContent()}</div>
        </div>
      </div>

      {/* loaders / overlays */}
      {/* <div className={`loader ${loadshow}`} style={{ zIndex: 1002 }}></div>
      <div className={`overlay-block ${overlayBlock}`} />
      <div className={`overly-block ${overlyBlock}`} onClick={hideOverlySlideBlock} /> */}
    </>
  );
};

export default InventoryDashboards;
